import React from 'react';
import { Link } from 'react-router-dom';
import logo from "../../assets/images/logo.png";
function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  return (
    <header className="bg-white text-[#0a8082] sticky top-0 z-50 shadow-lg border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4 flex-1 min-w-0">
             <img
              src={logo}
              alt="Praneesh Infotech"
              className="h-12 sm:h-14 md:h-16 w-auto object-contain"
            />
          </div>
           
          <button
            className="lg:hidden w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center text-3xl"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>

          <nav className="hidden lg:flex gap-6 font-medium text-lg items-center">
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/services">Services</Link>
            <Link to="/projects">Projects</Link>
            <Link to="/contact">Contact</Link>
          </nav>
        </div>

        {mobileMenuOpen && (
          <nav className="lg:hidden mt-5 bg-white rounded-3xl p-5 shadow-2xl flex flex-col gap-5 text-[#071E56] text-lg font-semibold">
            <Link
              to="/"
              onClick={() => setMobileMenuOpen(false)}
              className="border-b border-gray-100 pb-3"
            >
              Home
            </Link>

            <Link
              to="/about"
              onClick={() => setMobileMenuOpen(false)}
              className="border-b border-gray-100 pb-3"
            >
              About
            </Link>

            <Link
              to="/services"
              onClick={() => setMobileMenuOpen(false)}
              className="border-b border-gray-100 pb-3"
            >
              Services
            </Link>

            <Link
              to="/projects"
              onClick={() => setMobileMenuOpen(false)}
              className="border-b border-gray-100 pb-3"
            >
              Projects
            </Link>

            <Link
              to="/contact"
              onClick={() => setMobileMenuOpen(false)}
            >
              Contact
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
}

export default Header;
